import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppContent from './AppContent';
import Footer from './components/Footer';
import './App.css';

const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <div className="app-container">
          <main>
            <Routes>
              <Route exact path="/" element={<AppContent />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
